/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule fetch
 */

'use strict';

require('whatwg-fetch');
module.exports = self.fetch.bind(self);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-relay/~/fbjs/lib/fetch.js
 ** module id = 265
 ** module chunks = 0
 **/